import { useContext, useState } from "react";
import { useToast } from "../ToastContext";
import { LoadingContext } from "../LoadingContext";
import { AuthContext } from "../AuthContext";
import {
  getMessageTitleByUserIdGat,
  updateMessageTitleGat,
} from "../../gateways/SettingsGateway";

export interface AutoSignPayload {
  /** null mantém o valor atual; false desliga a assinatura automática. */
  autoSignEnabled?: boolean | null;
  /** String base64 da imagem. String vazia remove; undefined mantém a atual. */
  autoSignSignature?: string | null;
  autoSignDocument?: string | null;
}

export default function useSettings() {
  const showToast = useToast();
  const { setLoading } = useContext(LoadingContext);
  const { objUserTk } = useContext(AuthContext);

  const [messageTitle, setMessageTitle] = useState<string>("");
  const [messageEmailBody, setMessageEmailBody] = useState<string>("");

  const [autoSignEnabled, setAutoSignEnabled] = useState<boolean>(false);
  const [hasStoredSignature, setHasStoredSignature] = useState<boolean>(false);
  const [hasStoredDocument, setHasStoredDocument] = useState<boolean>(false);

  const updateMessageTitle = async (
    newTitle: string,
    newEmailBody?: string,
    autoSign?: AutoSignPayload
  ) => {
    try {
      setLoading(true);
      const result = await updateMessageTitleGat(
        objUserTk.UserId,
        newTitle,
        newEmailBody,
        autoSign
      );
      if (result) {
        showToast("success", "Sucesso ao atualizar");

        if (autoSign?.autoSignEnabled !== undefined && autoSign?.autoSignEnabled !== null) {
          setAutoSignEnabled(autoSign.autoSignEnabled);
        }
        if (autoSign?.autoSignSignature) {
          setHasStoredSignature(autoSign.autoSignSignature.length > 0);
        }
        if (autoSign?.autoSignDocument) {
          setHasStoredDocument(autoSign.autoSignDocument.length > 0);
        }

        setLoading(false);
      }
      return true;
    } catch (error: any) {
      console.log(error);
      showToast(
        "error",
        error?.response?.data?.error?.message || "Erro ao cadastrar"
      );
      setLoading(false);
      return false;
    }
  };

  const getMessageTitleByUserId = async (UserId: string) => {
    try {
      setLoading(true);
      const result = await getMessageTitleByUserIdGat(UserId);
      setMessageTitle(result.data?.messageTitle || "");
      setMessageEmailBody(result.data?.emailBody || "");
      // byte[] chega como string base64 (System.Text.Json padrão).
      setAutoSignEnabled(result.data?.autoSignEnabled ?? false);
      setHasStoredSignature(Boolean(result.data?.autoSignSignature));
      setHasStoredDocument(Boolean(result.data?.autoSignDocument));
      setLoading(false);
      return result.data;
    } catch (error: any) {
      console.log(error);
      // showToast(
      //   "error",
      //   error?.response?.data?.error?.message || "Erro ao buscar"
      // );
      setLoading(false);
    }
  };

  return {
    messageTitle,
    updateMessageTitle,
    setMessageTitle,
    getMessageTitleByUserId,
    messageEmailBody,
    setMessageEmailBody,
    autoSignEnabled,
    setAutoSignEnabled,
    hasStoredSignature,
    hasStoredDocument,
  };
}
